import { Component, OnInit, ViewChild } from "@angular/core";
import { TractorService } from "../shared/tractor.service";
import { Router } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { SelectItem } from "primeng/api";
import { FeatureFlagsService } from "@app/agilx/shared/feature-flags.service";

@Component({
  selector: "app-tractorlist",
  templateUrl: "./tractorlist.component.html",
  styleUrls: ["./tractorlist.component.css"],
})
export class TractorlistComponent implements OnInit {
  tractorsCols: any = [];
  errorMsg: any;
  allRecord: any;

  statusOptions: SelectItem[] = [
    { label: "ALL", value: null },
    { label: "ACTIVE", value: "Active" },
    { label: "INACTIVE", value: "Inactive" },
  ];

  constructor(
    private _tractorList: TractorService,
    private router: Router,
    private _AuthService: authenticationService,
    private featureFlagsService: FeatureFlagsService
  ) {}

  ngOnInit() {
    this.tractorsCols = [
      { field: "unitNumber", header: "Unit number", width: 120 },
      { field: "driverName", header: "Driver name" },
      { field: "year", header: "Year", width: 100 },
      { field: "make", header: "Manufacturer", width: 130 },
      { field: "licenseNumber", header: "License Plate", width: 120 },
      { field: "currentLocation", header: "Current Location", width: 180 },
      { field: "peopleNetUpdated", header: "Location Updated", width: 150 },
      { field: "active", header: "Status", width: 100, type: "boolean" },
      { field: "vinNo", header: "VIN", width: 120 },
    ];

    this._tractorList.findAndFilter().subscribe(
      (resTractorListData) => {
        this.allRecord = JSON.parse(JSON.stringify(resTractorListData));
      },
      (resTractorListError) => (this.errorMsg = resTractorListError)
    );
  }

  hasPermission(permissionName: string) {
    const permission = Permissions[permissionName];
    return this._AuthService.hasPermission(permission);
  }

  get newTractorRoute(): string {
    return this.featureFlagsService.isEnabled('useNewTractorPages') ? '/tractors/newtractor' : '/newtractor';
  }

  viewDetail(tractor) {
    if (this.featureFlagsService.isEnabled('useNewTractorPages')) {
      this.router.navigate(["/tractors/", tractor.id]);
    } else {
      this.router.navigate(["/tractorinfo/", tractor.id]);
    }
  }

  getCurrentLocation(tractor: any): string {
    if (!tractor.currentLocationCity && !tractor.currentLocationState) {
      return "-";
    }
    return [tractor.currentLocationCity, tractor.currentLocationState].filter(Boolean).join(", ");
  }

  getPeopleNetUpdated(tractor: any): string {
    const raw = tractor.peopleNetLocationUpdatedUtc;
    if (!raw) return "-";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return "-";

    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) {
      return "<1h ago";
    } else if (diffHours < 24) {
      return `${diffHours}h ago`;
    } else if (diffDays === 1) {
      return "1d ago";
    } else {
      return `${diffDays}d ago`;
    }
  }

  getPeopleNetUpdatedTooltip(tractor: any): string {
    const raw = tractor.peopleNetLocationUpdatedUtc;
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleString();
  }

  isPeopleNetStale(tractor: any): boolean {
    const raw = tractor.peopleNetLocationUpdatedUtc;
    if (!raw) return false;
    const d = new Date(raw);
    if (isNaN(d.getTime())) return false;

    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffHours = diffMs / (1000 * 60 * 60);

    return diffHours > 48;
  }
}
